import React, { Component } from 'react';
import './Fields.css'
import Api from '../services/api';
import AuthService from '../services/auth';
import checkCircle from '../static/vectors/check-circle.svg';
import Modal from 'react-modal';

class ProfileDescription extends Component {

  constructor(props) {
    super(props);

    this.state = {
      fields: {
        aboutMe: '',
        lookingForText: '',
      },
      isModalOpen: false,
      modalMessage: '',
      canSubmit: false,
    };
  }

  componentDidMount() {
    (new Api()).get('/users/current',{}, AuthService.getAuthCookie())
      .then(response => {
        const {aboutMe, lookingForText, id} = response.user;
        this.setState({
          fields: {
            aboutMe,
            lookingForText,
          },
          id,
        });
      });
  }

  handleSubmit(e) {
    e.preventDefault();
    let { fields, id } = this.state;

    (new Api()).put(`/users/${id}`, fields, AuthService.getAuthCookie())
      .then(response => {
        const {aboutMe, lookingForText, id} = response.user;
        this.setState({
          fields: {
            aboutMe,
            lookingForText,
          },
          isModalOpen: true,
          canSubmit: false,
          modalMessage: response.message,
          id,
        });
      });
  }

  handleFieldChange(e, name) {
    let fields = this.state.fields;

    fields[name] = e.target.value;

    this.setState({ fields, canSubmit: true, });
  }

  closeModal() {
    this.setState({
      isModalOpen: false,
    });
  }

  render() {
    const { fields, isModalOpen, modalMessage, canSubmit  } = this.state;
    const { title } = this.props;
    return (
      <div className="col col-12 col-md-8">
        <div className="title">
          {title}
        </div>
        <form>
          <div className="field-container text">
            <div className="field-title">About me:</div>
            <div className="row">
              <div className="col">
                <textarea
                  rows={4}
                  id="aboutMe"
                  name="aboutMe"
                  value={fields.aboutMe}
                  onChange={e => {this.handleFieldChange(e, e.target.name)}}
                />
              </div>
            </div>
          </div>
          <div className="field-container text">
            <div className="field-title">What I'm looking for:</div>
            <div className="row">
              <div className="col">
                <textarea
                  rows={4}
                  id="lookingForText"
                  name="lookingForText"
                  value={fields.lookingForText}
                  onChange={e => {this.handleFieldChange(e, e.target.name)}}
                />
              </div>
            </div>
          </div>
        </form>
        <button
          className="submit btn"
          disabled={!canSubmit}
          onClick={(e) => {this.handleSubmit(e);}}
        >
          Save profile
        </button><Modal
        isOpen={isModalOpen}
        onRequestClose={() => {this.closeModal()}}
        contentLabel="Example Modal"
        style={{
          content: {
            top: '50%',
            bottom: 'auto',
            left: '50%',
            right: 'auto',
            transform: 'translate(-50%, -50%)',
          }
        }}
      >
        <div className="content text-center">
          <img src={checkCircle} alt="check" />
          <div className="message">{modalMessage}</div>
          <button onClick={() => {this.closeModal()}}> Close X</button>
        </div>
      </Modal>
      </div>
    )
  }
}

export default ProfileDescription;


// WEBPACK FOOTER //
// ./src/components/ProfileDescription.js